// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__HzWrM","subTitle":"styles_subTitle__g+jX1","category_back":"styles_category_back__KTpyB"};